import React, {memo} from "react";
import {ProgressBar, ScrollMode, SpecialZoomLevel, Viewer, Worker} from "@react-pdf-viewer/core";
import {Box} from "@mui/material";

const PDFViewer = memo(({objectUrl}: { objectUrl: string }) => (
    <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`}>
        <Viewer
            fileUrl={objectUrl}
            defaultScale={SpecialZoomLevel.PageWidth}
            scrollMode={ScrollMode.Vertical}
            initialPage={0}
            renderLoader={(percentages: number) => (
                <Box sx={{width: '40%'}}>
                    <ProgressBar progress={Math.round(percentages)}/>
                </Box>
            )}
        />
    </Worker>
));

export default PDFViewer;